import { ApiFactory } from 'webtoolkit';
import _isUndefined from 'lodash/isUndefined';
const moduleName = require('../../../datashop.json').name;

const appConfig = window.datashop.app.module('getPublicConfig')(moduleName);
const {
  host,
  api: { base }
} = appConfig;

const BASE_URL = `${host}${base}`;

const api = new ApiFactory({
  apiBase: BASE_URL,
  credentials: 'include'
});

const getDeployedStandardETL = () => {
  return api.get(`/${moduleName}/standard-etl`);
};

const getStandardETLVersions = (currentVersion) => {
  return api.get(`/${moduleName}/versions?currentVersion=${currentVersion}`);
};

const getStandardETLVersionDetails = (version) => {
  return api.get(`/${moduleName}/version/details?version=${version}`);
};

const getUpdatedStandardETL = (payload) => {
  return api.post(`/${moduleName}/update`, {
    body: JSON.stringify(payload)
  });
};

const getStandardETLVersionUpdateReport = (version) => {
  return api.get(`/${moduleName}/version/report`);
};

const getExecutionSettingsConfig = () => {
  return api.get(`/${moduleName}/execution-settings`);
};

const getExecutionSettingsData = (payload) => {
  return api.get(
    `/${moduleName}/execution-settings/workspace/${payload.workspaceID}/workflow/${payload.workflowID}/config`
  );
};

const saveExecutionSettings = (params, payload) => {
  return api.post(
    `/${moduleName}/execution-settings/workspace/${params.workspaceID}/workflow/${params.workflowID}/config`,
    {
      body: JSON.stringify(payload)
    }
  );
};

const getReleaseNotesUrl = () => {
  return api.get(`/${moduleName}/releaseUrl`);
};

export default {
  getDeployedStandardETL,
  getStandardETLVersions,
  getStandardETLVersionDetails,
  getUpdatedStandardETL,
  getStandardETLVersionUpdateReport,
  getExecutionSettingsConfig,
  getExecutionSettingsData,
  saveExecutionSettings,
  getReleaseNotesUrl
};
